import { render, staticRenderFns } from "./CompanyLog.vue?vue&type=template&id=61a8ad50&scoped=true"
import script from "./CompanyLog.vue?vue&type=script&lang=js"
export * from "./CompanyLog.vue?vue&type=script&lang=js"
import style0 from "./CompanyLog.vue?vue&type=style&index=0&id=61a8ad50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8ad50",
  null
  
)

export default component.exports